import { render } from "./App.vue?vue&type=template&id=34759360"
const script = {}

import exportComponent from "C:\\Users\\liuqi\\Desktop\\R\\hkyl-fintech-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__